<template>
  <v-container fluid fill-height>
    <v-row class="d-flex justify-center my-0 py-0">
      <v-col cols="9" xl="7" lg="7" md="7" sm="7">
        <v-text-field
          v-model="search"
          dense
          hide-details=""
          prepend-inner-icon="mdi-magnify"
          :label="translations.search"
          background-color="white"
          outlined
          :loading="loading"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="loading">
      <v-col cols="12" v-for="item in 6" :key="item" class="py-2">
        <v-skeleton-loader
          type="list-item-av
        atar-three-line"
        />
      </v-col>
    </v-row>
    <v-row v-else class="mb-5">
      <v-col
        cols="12"
        xl="4"
        lg="4"
        md="4"
        sm="6"
        xs="12"
        v-for="(project, index) in projects"
        :key="index"
        no-gutters
        class="py-2"
      >
        <ProyectItem
          :project="project"
          @clickItem="goToDetail"
          @updateItem="goToUpdateItem"
        />
      </v-col>
    </v-row>
    <div class="overlayCenter" v-if="!loading && projects.length <= 0">
      <p class="text-center">{{ translations.label_no_projects }}</p>
    </div>
    <!-- copyright -->
    <v-footer class="text-caption text-center d-flex justify-center" fixed>
      D.R. © Solena Ag, Inc. {{new Date().getFullYear()}}
    </v-footer>
  </v-container>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
//Components
import ProyectItem from "@/components/territory/ProyectItem.vue";
export default {
  components: {
    ProyectItem,
  },
  data: () => ({
    search: null,
    projects: [],
    page: 1,
    totalPages: 0,
    isMoreData: true,
    loading: false,
    organizationId: "",
    busyGettingData: false,
    loadThreshold: 200,
  }),
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
  },
  methods: {
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    ...mapActions("project", ["getProjects"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    goBack() {
      this.$router.push(`/seller-list/client/`);
    },
    goToDetail(projectId) {
      this.$router.push(`/proyect-detail/${projectId}`);
    },
    goToUpdateItem(projectId) {
      this.$router.push(`/proyect-form/${projectId}`);
    },
    async handleScroll() {
      try {
        const scrollHeight = document.documentElement.scrollHeight;
        const scrollTop =
          window.pageYOffset !== undefined
            ? window.pageYOffset
            : (
                document.documentElement ||
                document.body.parentNode ||
                document.body
              ).scrollTop;
        const clientHeight = document.documentElement.clientHeight;
        const threshold = 1000;

        if (scrollTop + clientHeight >= scrollHeight - threshold) {
          if (!this.busyGettingData && this.isMoreData) {
            this.page++;
            await this.fetchData();
          }
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al cargar, intente de nuevo",
          timeout: 4000,
        });
      }
    },
    async fetchData() {
      this.busyGettingData = true;
      try {
        let response = await this.getProjects({
          clientId: this.organizationId,
          page: this.page,
          search: this.search,
        });
        if (response) {
          if (!response.error) {
            this.projects.push(...response.projects);
            this.totalPages = response.pages;

            if (this.totalPages == this.page - 1) {
              this.isMoreData = false;
            } else {
            }
          } else {
            console.log(response.message);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: "Algo salio mal al cargar, intente de nuevo",
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: "Algo salio mal al cargar, intente de nuevo",
            timeout: 4000,
          });
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al cargar, intente de nuevo",
          timeout: 4000,
        });
      }
      this.loading = false;
      this.busyGettingData = false;
      await this.checkIfContentHeightLessThanViewport();
    },
    async checkIfContentHeightLessThanViewport() {
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        scrollHeight <= clientHeight &&
        this.isMoreData &&
        !this.busyGettingData
      ) {
        this.page++;
        await this.fetchData();
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  async mounted() {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
      if (user.role == "ORG_USER_ADMIN") {
        this.organizationId = localStorage.getItem("organizationId");
        this.SET_APPBAR_OPTIONS({
          leftButton: "menu",
          // rightButton: "proyect_add",
        });
      } else {
        this.organizationId = localStorage.getItem("organizationId");
        this.SET_APPBAR_OPTIONS({
          leftButton: "menu",
        });
      }
    } else {
      this.organizationId = localStorage.getItem("clientId");
      this.SET_APPBAR_OPTIONS({
        leftButton: "menu_seller",
        // rightButton: "proyect_add",
        funcLeftButton: this.goBack,
      });
    }
    await this.fetchData();
    window.addEventListener("scroll", this.handleScroll);
  },
  watch: {
    async search() {
      this.projects = [];
      this.loading = true;
      this.page = 1;
      await this.fetchData();
    },
  },
};
</script>

<style scoped>
.overlayCenter {
  display: fixed;
  flex: 100%;
  top: 50%;
  left: 20%;
  right: 20%;
  bottom: 50%;
  z-index: 1;
  position: absolute;
}
</style>
